import React, { createContext, useState, useContext } from 'react'
import { useSelector } from 'react-redux'
import loadable from '@loadable/component'
// const SuccessModal = loadable(() => import('../component/Modals/SuccessModal'))
const ConfirmModal = loadable(() => import('../component/Modals/ConfirmModal'))
const NoActionModal = loadable(() =>
  import('../component/Modals/NoActionModal'),
)
const ActionChoiceModal = loadable(() =>
  import('../component/Modals/ActionChoiceModal'),
)

const GeneralModalContext = createContext()

export const useGeneralModal = () => useContext(GeneralModalContext)

const GeneralModalProvider = ({ children }) => {
  const fullScreenActive = useSelector(state => state.common.fullScreenActive)
  // const [successModal, setSuccessModal] = useState(null)
  const [confirmModal, setConfirmModal] = useState(null)
  const [noActionModal, setNoActionModal] = useState(null)
  const [actionChoiceModal, setActionChoiceModal] = useState(null)

  return (
    <GeneralModalContext.Provider
      value={{
        // setSuccessModal,
        confirmModal,
        noActionModal,
        actionChoiceModal,
        setConfirmModal,
        setNoActionModal,
        setActionChoiceModal,
      }}
    >
      {children}
      {/* {successModal && <SuccessModal {...successModal} />} */}
      {confirmModal && !fullScreenActive && <ConfirmModal {...confirmModal} />}
      {noActionModal && !fullScreenActive && (
        <NoActionModal {...noActionModal} />
      )}
      {actionChoiceModal && !fullScreenActive && (
        <ActionChoiceModal {...actionChoiceModal} />
      )}
    </GeneralModalContext.Provider>
  )
}

export default GeneralModalProvider
